import { vuexfireMutations, firestoreAction } from 'vuexfire'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import axios from 'axios'


import crypto from "crypto";

const generateHash = (text) => {
  if (!text){
    return null
  } else {
    

    let string = text.replace(/\s/g, '')
    return crypto.createHash('md5').update(string).digest("hex")
  }
}

const pipelineApiKey = "7hsWCpnq7Y5WKATNvCAQM6BVAVnsAWpoxudZzgCj"
const pipelineApiConfig = {
    "headers": {
        "x-api-key": pipelineApiKey,
        "Content-Type": "application/json"
    }
}

const actions = {
    
    addDocuments(_, { projectId, add }) {
        let dataId = generateHash(add.text)
        if (!dataId) return;
        
        add.createdAt = firebase.firestore.FieldValue.serverTimestamp()
        add.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
        add.dataId = dataId
        add.id = dataId
        firebase.firestore().doc(`projects/${projectId}/documents/${dataId}`).set(add)
        return add
    },
    updateProjectDocuments(_, { projectId, dataId, update }) {
        update.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
        if (dataId === undefined || dataId === 'sample'){
          firebase.firestore().collection(`projects/${projectId}/documents`).add(update)
        } else {
          firebase.firestore().doc(`projects/${projectId}/documents/${dataId}`).update(update)
        }

        firebase.firestore().doc(`projects/${projectId}`).update({
          'state.train.status': 'triggering'
        })

    },
    deleteProjectDocuments(_, { projectId, dataId }) {
        console.log({ projectId, dataId })
        firebase.firestore().collection(`projects/${projectId}/documents`).doc(`${dataId}`).delete()

    },
    // currentProjectDocuments: firestoreAction(({ bindFirestoreRef, state }, projectId) => {
    //     let stateKey = `documents-${projectId}`
        
    //     if (state[stateKey] != undefined && state[stateKey].length > 0) {
    //       return
    //     }
        
    //     return bindFirestoreRef(stateKey, 
    //       firebase.firestore()
    //       .collection(`projects/${projectId}/documents`)
    //     )
    // }),
    getRows: ({commit}, datasetId) => {
        const api = `${process.env.VUE_APP_PIPELINE_URL}/v1/pipeline/rows/get-by-dataset/${datasetId}`
        axios.get(api, pipelineApiConfig).then( (r) => {
            console.log("list rows: ", r.data.length)
            commit('SET_ROWS', r.data)
        })
    },
}

export default actions